import { CrisisStreamResponse } from 'types/Crisis/crisis-stream'
import { InferType, object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object({
  eventStreamId: string().required(),
  sentBackBy: string().optional(),
  sentBackById: string().optional(),
  sentBackByName: string().optional(),
}).required()

export type Request = InferType<typeof Schema>

export type SuccessfulResponse = CrisisStreamResponse

export const url = ({ eventStreamId }: { eventStreamId: string }) => `/v1/crisis-streams/${eventStreamId}/requeue-visit`

export const getBody = ({ sentBackBy, sentBackById, sentBackByName }: Request) => ({
  sentBackBy,
  sentBackById,
  sentBackByName,
})
